import config from 'constants/config'
import { Experiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'
import { useAppSelector } from 'hooks/reduxHooks'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'

export function isSearchMapRedesignEligible(pathname: string, brand: string, hasValidSearch: boolean): boolean {
  return brand === 'luxuryescapes' && hasValidSearch && !!matchLocaleAwarePath(pathname, {
    path: '/:regionCode/search/map',
    exact: true,
  })
}

export default function useSearchMapRedesign(hasValidSearch: boolean): boolean {
  const pathname = useAppSelector(state => state.router.location.pathname)
  const eligible = isSearchMapRedesignEligible(pathname, config.BRAND, hasValidSearch)
  const { variation } = useExperiment(Experiments.searchMapRedesign, { canActivate: eligible })
  return eligible && variation === 'on'
}
